"use strict";

var _interopRequireDefault = require("/var/www/html/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _typeof3 = require("/var/www/html/node_modules/@babel/runtime/helpers/typeof.js");
require("core-js/modules/es6.weak-map");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.array.find-index");
var _toConsumableArray2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _typeof2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("core-js/modules/es6.string.iterator");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/web.dom.iterable");
var XLSX = _interopRequireWildcard(require("xlsx/xlsx.mjs"));
var _utils = require("@/utils");
var _funnel = require("@/api/funnel");
var _funnelChart = _interopRequireDefault(require("./components/funnel-chart"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    FunnelChart: _funnelChart.default
  },
  data: function data() {
    return {
      failedTableTotalPage: 1,
      failedTableCurrentPage: 1,
      failedTablePerPage: 100,
      failedTableTotal: 0,
      failedTableCurrentPageTotal: 0,
      //

      funnelData: [],
      // 漏斗数据
      dimensionData: [],
      // 维度数据
      failedData: [],
      // 加粉不成功订单明细

      loadingFunnelData: false,
      // 是否正在加载漏斗数据
      loadingDimensionData: false,
      // 是否正在加载维度数据
      loadingFailedData: false,
      // 是否正在加载加粉不成功订单明细数据
      isExportingFailedTable: false,
      // 是否正在导出加粉不成功订单明细表格
      isExportingDimensionTable: false,
      // 是否正在导出维度表格
      showFailedTable: false,
      // 是否展示加粉不成功表格（默认不展示，点击漏斗再展示）
      showDimensionTable: false,
      // 是否展示维度表格（默认不展示，实际调用接口再展示）

      allFailedReason: '所有失败订单',
      selectedFailedReason: '',
      // 选中加粉不成功的原因（点击漏斗）

      failedReasonsMap: {},
      // 加粉失败原因
      failedReasons: [],
      // 失败原因列表
      patterns: [],
      // 模型列表（使用 pattern_product_id）
      guideDepartments: [],
      // 导粉部门列表
      acceptDepartments: [],
      // 接粉部门列表
      channelGroups: [],
      // 渠道分类列表
      // 维度（value值与后端对齐）
      dimensions: [{
        label: '流量分发部门',
        value: 'daofen_department'
      }, {
        label: '渠道分类',
        value: 'channel_zaiti'
      }, {
        label: '流量分发模型',
        value: 'pattern'
      }, {
        label: '流量接收部门',
        value: 'jiefen_department'
      }],
      // 维度明细表格的指标列配置
      // countKey/rateKey 为后端下发的原始字段名，组装时在源头格式化（千分位 / 带 %）
      dimensionMetrics: [{
        label: '测算订单数',
        countKey: 'cs_order_cn',
        rateKey: 'cs_order_base_rate'
      }, {
        label: '手机采集率',
        countKey: 'cs_phone_cn',
        rateKey: 'cs_phone_base_rate'
      }, {
        label: '导粉页打开率',
        countKey: 'daofen_page_cn',
        rateKey: 'daofen_page_base_rate'
      }, {
        label: '场景活码生成率',
        countKey: 'xiafa_cn',
        rateKey: 'xiafa_base_rate'
      }, {
        label: '加粉点击率',
        countKey: 'click_link_cn',
        rateKey: 'click_link_base_rate'
      }, {
        label: '获客链接打开率',
        countKey: 'open_link_cn',
        rateKey: 'open_link_base_rate'
      }, {
        label: '获客链接发起添加率',
        countKey: 'start_add_cn',
        rateKey: 'start_add_base_rate',
        width: 150
      }, {
        label: '加粉成功率',
        countKey: 'add_cn',
        rateKey: 'add_base_rate'
      }, {
        label: '账号异常率',
        countKey: 'abnormal_cn',
        rateKey: 'abnormal_base_rate'
      }],
      searchPatterns: [],
      // 搜索的模型
      searchAccepts: [],
      // 搜索的接粉部门
      searchGuides: [],
      // 搜索的导粉部门
      searchChannelGroups: [],
      // 搜索的渠道分类
      searchDimensions: [],
      // 搜索的维度

      filterFailedOrderNo: '',
      filterFailedPattern: '',
      filterFailedGuide: '',
      filterFailedAccept: '',
      filterFailedChannelGroup: '',
      filterFailedRobotId: '',
      filterFailedRobotName: '',
      filterFailedPaidDateRange: [],
      // 加粉不成功订单明细-测算支付日期筛选

      defaultTime: ['00:00:00', '23:59:59'],
      paidDateRange: function () {
        var start = new Date();
        start.setHours(0, 0, 0, 0);
        var end = new Date();
        end.setHours(23, 59, 59, 0);
        return [start, end];
      }(),
      // 支付日期范围（默认今天）
      fansDataRange: [],
      // 加粉日期范围
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setTime(end.getTime() - 3600 * 1000 * 24);
            end.setHours(23, 59, 59, 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '上月',
          onClick: function onClick(picker) {
            var now = new Date();
            var year = now.getFullYear();
            var month = now.getMonth();
            var start = new Date(year, month - 1, 1);
            start.setHours(0, 0, 0, 0);
            // 当月第 0 天即为上月最后一天，自动处理跨年
            var end = new Date(year, month, 0);
            end.setHours(23, 59, 59, 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '本月(不含今天)',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setTime(end.getTime() - 3600 * 1000 * 24);
            end.setHours(23, 59, 59, 0);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  },
  computed: {
    // 加粉不成功明细表格各列筛选项
    // 以字段值为 key 去重，保证每个值只出现一条筛选项
    failedTableFilters: function failedTableFilters() {
      var props = ['pattern_name', 'daofen_department', 'jiefen_department', 'channel_zaiti', 'robot_id', 'robot_name'];
      var filters = {};
      var seen = {};
      props.forEach(function (prop) {
        filters[prop] = [];
        seen[prop] = {};
      });
      if (this.failedData.length === 0) {
        return filters;
      }
      this.failedData.forEach(function (row) {
        props.forEach(function (prop) {
          var value = row[prop];
          if (value && !seen[prop][value]) {
            seen[prop][value] = true;
            filters[prop].push({
              text: value,
              value: value
            });
          }
        });
      });
      return filters;
    },
    // 加粉不成功明细表格-根据表头筛选条件过滤后的数据
    displayFailedData: function displayFailedData() {
      var pattern = this.filterFailedPattern;
      var guide = this.filterFailedGuide;
      var accept = this.filterFailedAccept;
      var channel = this.filterFailedChannelGroup;
      var robotId = this.filterFailedRobotId;
      var robotName = this.filterFailedRobotName;
      var orderNo = this.filterFailedOrderNo && this.filterFailedOrderNo.trim();
      var paidRange = this.filterFailedPaidDateRange || [];
      var paidStart = paidRange[0] ? (0, _utils.parseTime)(paidRange[0], '{y}-{m}-{d}') : '';
      var paidEnd = paidRange[1] ? (0, _utils.parseTime)(paidRange[1], '{y}-{m}-{d}') : '';
      return this.failedData.filter(function (row) {
        if (pattern && row.pattern_name !== pattern) return false;
        if (guide && row.daofen_department !== guide) return false;
        if (accept && row.jiefen_department !== accept) return false;
        if (channel && row.channel_zaiti !== channel) return false;
        if (robotId && String(row.robot_id) !== String(robotId)) return false;
        if (robotName && row.robot_name !== robotName) return false;
        if (orderNo && !String(row.order_id).includes(orderNo)) return false;
        if (paidStart || paidEnd) {
          var orderDate = row.order_time ? String(row.order_time).split(' ')[0] : '';
          if (!orderDate) return false;
          if (paidStart && orderDate < paidStart) return false;
          if (paidEnd && orderDate > paidEnd) return false;
        }
        return true;
      });
    },
    // 汇总标题
    summaryTitle: function summaryTitle() {
      if (this.searchDimensions.length === 0) {
        return '组合汇总';
      }
      var dimensionMap = {};
      this.dimensions.forEach(function (item) {
        dimensionMap[item.value] = item.label;
      });
      var labels = this.searchDimensions.map(function (value) {
        return dimensionMap[value];
      }).filter(Boolean);
      return "".concat(labels.join(' + '), "\u7EC4\u5408\u6C47\u603B");
    },
    // 是否显示流量分发模型列
    showPatternColumn: function showPatternColumn() {
      return this.dimensionData.some(function (row) {
        return !!row.pattern;
      });
    },
    // 是否显示流量分发部门列
    showGuideColumn: function showGuideColumn() {
      return this.dimensionData.some(function (row) {
        return !!row.daofen_department;
      });
    },
    // 是否显示流量接收部门列
    showAcceptColumn: function showAcceptColumn() {
      return this.dimensionData.some(function (row) {
        return !!row.jiefen_department;
      });
    },
    // 是否显示渠道分类列
    showChannelColumn: function showChannelColumn() {
      return this.dimensionData.some(function (row) {
        return !!row.channel_zaiti;
      });
    }
  },
  watch: {
    selectedFailedReason: function selectedFailedReason(newVal, oldVal) {
      if (newVal && newVal != oldVal) {
        this.failedTableTotalPage = 1;
        this.failedTableCurrentPage = 1;
        this.failedTableTotal = 0;
        this.clearFailedFilter();
        this.getFailedData();
      }
    }
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    // 模型全选处理
    onSelectAllPatterns: function onSelectAllPatterns() {
      this.searchPatterns = this.patterns.map(function (item) {
        return item.value;
      });
    },
    // 导粉部门全选处理
    onSelectAllGuideDepartments: function onSelectAllGuideDepartments() {
      this.searchGuides = this.guideDepartments.map(function (item) {
        return item.value;
      });
    },
    // 接粉部门全选处理
    onSelectAllAcceptDepartments: function onSelectAllAcceptDepartments() {
      this.searchAccepts = this.acceptDepartments.map(function (item) {
        return item.value;
      });
    },
    // 渠道分类全选处理
    onSelectAllChannelGroups: function onSelectAllChannelGroups() {
      this.searchChannelGroups = this.channelGroups.map(function (item) {
        return item.value;
      });
    },
    // 获取选项数据
    init: function () {
      var _init = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return Promise.all([this.getGuideDepartments(), this.getAcceptDepartments(), this.getChannelGroups(), this.getPatterns(), this.getFailedReason()]);
            case 3:
              // 上述所有接口成功，拉取漏斗数据和维度数据
              this.getFunnelData();
              this.getDimensionData();
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.log(_context.t0);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 7]]);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }(),
    // 获取导粉部门列表
    getGuideDepartments: function () {
      var _getGuideDepartments = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (0, _funnel.getGuideDepartmentOption)();
            case 3:
              res = _context2.sent;
              if (res.data && Array.isArray(res.data)) {
                this.guideDepartments = res.data.map(function (item) {
                  var value = item.daofen_department;
                  return {
                    label: value,
                    value: value
                  };
                });
                // 默认选中「用户增长部」
                if (this.guideDepartments.some(function (item) {
                  return item.value === '用户增长部';
                })) {
                  this.searchGuides.push('用户增长部');
                }
              }
              _context2.next = 10;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              console.log(_context2.t0);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 7]]);
      }));
      function getGuideDepartments() {
        return _getGuideDepartments.apply(this, arguments);
      }
      return getGuideDepartments;
    }(),
    // 获取接收部门列表
    getAcceptDepartments: function () {
      var _getAcceptDepartments = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return (0, _funnel.getAcceptDepartmentOption)();
            case 3:
              res = _context3.sent;
              if (res.data && Array.isArray(res.data)) {
                this.acceptDepartments = res.data.map(function (item) {
                  var value = item.jiefen_department;
                  return {
                    label: value,
                    value: value
                  };
                });
              }
              _context3.next = 10;
              break;
            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
              console.log(_context3.t0);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 7]]);
      }));
      function getAcceptDepartments() {
        return _getAcceptDepartments.apply(this, arguments);
      }
      return getAcceptDepartments;
    }(),
    // 获取渠道分类列表
    getChannelGroups: function () {
      var _getChannelGroups = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return (0, _funnel.getChannelGroupOption)();
            case 3:
              res = _context4.sent;
              if (res.data && Array.isArray(res.data)) {
                this.channelGroups = res.data.map(function (item) {
                  var value = item.channel_zaiti;
                  return {
                    label: value,
                    value: value
                  };
                });
              }
              _context4.next = 10;
              break;
            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);
              console.log(_context4.t0);
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 7]]);
      }));
      function getChannelGroups() {
        return _getChannelGroups.apply(this, arguments);
      }
      return getChannelGroups;
    }(),
    // 获取失败原因
    getFailedReason: function () {
      var _getFailedReason = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res, data, sortKeys;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return (0, _funnel.getFailedReasonOption)();
            case 3:
              res = _context5.sent;
              if (res.data && (0, _typeof2.default)(res.data) === 'object') {
                data = res.data;
                this.failedReasonsMap = data;
                sortKeys = ['all_failure', 'no_phone', 'no_daofen_page', 'no_xiafa', 'no_click_link', 'no_open_link', 'no_start_add', 'no_add'];
                this.failedReasons = sortKeys.filter(function (key) {
                  return key in data;
                }).map(function (key) {
                  return {
                    value: data[key],
                    label: data[key]
                  };
                });
              }
              _context5.next = 10;
              break;
            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5["catch"](0);
              console.log(_context5.t0);
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 7]]);
      }));
      function getFailedReason() {
        return _getFailedReason.apply(this, arguments);
      }
      return getFailedReason;
    }(),
    // 获取模型列表
    getPatterns: function () {
      var _getPatterns = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return (0, _funnel.getPatternOption)();
            case 3:
              res = _context6.sent;
              if (res.data) {
                this.patterns = res.data.map(function (item) {
                  var pattern_name = item.pattern_name,
                    pattern = item.pattern,
                    scene_id = item.scene_id;
                  var label = "".concat(pattern_name, "-").concat(pattern, "-").concat(scene_id);
                  var value = pattern;
                  return {
                    label: label,
                    value: value
                  };
                });
                // 默认全选
                this.searchPatterns = this.patterns.map(function (item) {
                  return item.value;
                });
              }
              _context6.next = 10;
              break;
            case 7:
              _context6.prev = 7;
              _context6.t0 = _context6["catch"](0);
              console.log(_context6.t0);
            case 10:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[0, 7]]);
      }));
      function getPatterns() {
        return _getPatterns.apply(this, arguments);
      }
      return getPatterns;
    }(),
    // 获取通用请求参数
    getRequestParams: function getRequestParams() {
      var DATE_FMT = '{y}-{m}-{d}';
      var params = {
        pattern: this.searchPatterns.join(','),
        daofen_department: this.searchGuides.join(','),
        jiefen_department: this.searchAccepts.join(','),
        channel_zaiti: this.searchChannelGroups.join(','),
        dimension: this.searchDimensions.join(',')
      };
      if (this.paidDateRange.length > 0) {
        params['start_order_time'] = (0, _utils.parseTime)(this.paidDateRange[0], DATE_FMT);
        params['end_order_time'] = (0, _utils.parseTime)(this.paidDateRange[1], DATE_FMT);
      }
      if (this.fansDataRange.length > 0) {
        params['start_add_date'] = (0, _utils.parseTime)(this.fansDataRange[0], DATE_FMT);
        params['end_add_date'] = (0, _utils.parseTime)(this.fansDataRange[1], DATE_FMT);
      }

      // 维度特殊处理
      if (this.searchDimensions.length > 0) {
        // 判断是否包含 pattern 选项，若包含，则需要在 pattern 后面加 pattern_name、scene_id（后端要求）
        var dimensions = (0, _toConsumableArray2.default)(this.searchDimensions);
        var index = dimensions.findIndex(function (item) {
          return item === 'pattern';
        });
        if (index !== -1) {
          dimensions.splice(index + 1, 0, 'pattern_name', 'scene_id');
        }
        params['dimension'] = dimensions.join(',');
      }
      return params;
    },
    // 获取漏斗数据（汇总）
    getFunnelData: function () {
      var _getFunnelData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var params, response, data, result;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              params = this.getRequestParams();
              _context7.prev = 1;
              this.loadingFunnelData = true;
              _context7.next = 5;
              return (0, _funnel.getFunnelAnalysisStatisticsSummary)(params);
            case 5:
              response = _context7.sent;
              data = response && response.data; // 兼容 data 为数组或对象两种返回结构
              result = Array.isArray(data) ? data[0] : data;
              if (result) {
                this.assembleFunnelData(result);
              } else {
                this.funnelData = [];
              }
              _context7.next = 14;
              break;
            case 11:
              _context7.prev = 11;
              _context7.t0 = _context7["catch"](1);
              console.log(_context7.t0);
            case 14:
              _context7.prev = 14;
              this.loadingFunnelData = false;
              return _context7.finish(14);
            case 17:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[1, 11, 14, 17]]);
      }));
      function getFunnelData() {
        return _getFunnelData.apply(this, arguments);
      }
      return getFunnelData;
    }(),
    // 获取维度数据
    getDimensionData: function () {
      var _getDimensionData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var params, response, data, result;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!(this.searchDimensions.length === 0)) {
                _context8.next = 4;
                break;
              }
              this.dimensionData = [];
              this.showDimensionTable = false;
              return _context8.abrupt("return");
            case 4:
              this.showDimensionTable = true;
              params = this.getRequestParams();
              _context8.prev = 6;
              this.loadingDimensionData = true;
              _context8.next = 10;
              return (0, _funnel.getFunnelAnalysisStatisticsDetail)(params);
            case 10:
              response = _context8.sent;
              data = response && response.data;
              result = Array.isArray(data) ? data : [];
              this.dimensionData = this.assembleDimensionData(result);
              _context8.next = 19;
              break;
            case 16:
              _context8.prev = 16;
              _context8.t0 = _context8["catch"](6);
              console.log(_context8.t0);
            case 19:
              _context8.prev = 19;
              this.loadingDimensionData = false;
              return _context8.finish(19);
            case 22:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[6, 16, 19, 22]]);
      }));
      function getDimensionData() {
        return _getDimensionData.apply(this, arguments);
      }
      return getDimensionData;
    }(),
    // 获取加粉失败订单数据
    getFailedData: function () {
      var _getFailedData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var params, response, result, list, pages, total;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              params = this.getRequestParams();
              params['pageNum'] = this.failedTableCurrentPage;
              params['pageSize'] = this.failedTablePerPage;
              params['failure_reason'] = this.selectedFailedReason || this.failedReasonsMap['all_failure'];

              // 原因
              _context9.prev = 4;
              this.loadingFailedData = true;
              _context9.next = 8;
              return (0, _funnel.getFunnelAnalysisOrderDetail)(params);
            case 8:
              response = _context9.sent;
              if (response.data) {
                result = response.data ? response.data : {};
                list = result.list, pages = result.pages, total = result.total;
                this.failedTableTotalPage = pages;
                this.failedTableTotal = total;
                this.failedData = list;
              }
              _context9.next = 15;
              break;
            case 12:
              _context9.prev = 12;
              _context9.t0 = _context9["catch"](4);
              console.log(_context9.t0);
            case 15:
              _context9.prev = 15;
              this.loadingFailedData = false;
              return _context9.finish(15);
            case 18:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[4, 12, 15, 18]]);
      }));
      function getFailedData() {
        return _getFailedData.apply(this, arguments);
      }
      return getFailedData;
    }(),
    // 组装漏斗数据
    assembleFunnelData: function assembleFunnelData(data) {
      var cs_order_cn = data.cs_order_cn,
        cs_order_base_rate = data.cs_order_base_rate,
        cs_order_upper_rate = data.cs_order_upper_rate,
        cs_phone_cn = data.cs_phone_cn,
        cs_phone_base_rate = data.cs_phone_base_rate,
        cs_phone_upper_rate = data.cs_phone_upper_rate,
        daofen_page_cn = data.daofen_page_cn,
        daofen_page_base_rate = data.daofen_page_base_rate,
        daofen_page_upper_rate = data.daofen_page_upper_rate,
        xiafa_cn = data.xiafa_cn,
        xiafa_base_rate = data.xiafa_base_rate,
        xiafa_upper_rate = data.xiafa_upper_rate,
        click_link_cn = data.click_link_cn,
        click_link_base_rate = data.click_link_base_rate,
        click_link_upper_rate = data.click_link_upper_rate,
        open_link_cn = data.open_link_cn,
        open_link_base_rate = data.open_link_base_rate,
        open_link_upper_rate = data.open_link_upper_rate,
        start_add_cn = data.start_add_cn,
        start_add_base_rate = data.start_add_base_rate,
        start_add_upper_rate = data.start_add_upper_rate,
        add_cn = data.add_cn,
        add_base_rate = data.add_base_rate,
        add_upper_rate = data.add_upper_rate;
      // 在源头统一格式化：count 千分位，比率带 %，「-」原样保留
      // 下游（图表/表格/导出）直接消费，无需再各自处理数据格式
      var buildItem = function buildItem(failedReason, title, desc, count, baseRate, upperRate) {
        return {
          failedReason: failedReason,
          title: title,
          desc: desc,
          count: (0, _utils.formatCount)(count),
          baseRate: (0, _utils.formatRate)(baseRate),
          upperRate: (0, _utils.formatRate)(upperRate)
        };
      };
      this.funnelData = [buildItem(this.failedReasonsMap['all_failure'], '测算订单数', '支付测算订单基准', cs_order_cn, cs_order_base_rate, cs_order_upper_rate), buildItem(this.failedReasonsMap['no_phone'], '手机采集率', '测算订单采集到手机号', cs_phone_cn, cs_phone_base_rate, cs_phone_upper_rate), buildItem(this.failedReasonsMap['no_daofen_page'], '导粉页打开率', '导粉页实际打开订单', daofen_page_cn, daofen_page_base_rate, daofen_page_upper_rate), buildItem(this.failedReasonsMap['no_xiafa'], '场景活码生成率', '场景活码下发并生成', xiafa_cn, xiafa_base_rate, xiafa_upper_rate), buildItem(this.failedReasonsMap['no_click_link'], '加粉点击率', '用户点击加粉入口', click_link_cn, click_link_base_rate, click_link_upper_rate), buildItem(this.failedReasonsMap['no_open_link'], '获客链接打开率', '获客链接被打开', open_link_cn, open_link_base_rate, open_link_upper_rate), buildItem(this.failedReasonsMap['no_start_add'], '获客链接发起添加率', '发起好友添加动作', start_add_cn, start_add_base_rate, start_add_upper_rate), buildItem(this.failedReasonsMap['no_add'], '加粉成功率', '最终添加成功订单', add_cn, add_base_rate, add_upper_rate)];
    },
    // 组装维度数据
    // 在源头统一格式化：count 千分位，比率带 %，「-」原样保留
    // 下游（表格/导出）直接消费，无需再各自拼接 % 或处理千分位
    assembleDimensionData: function assembleDimensionData(list) {
      var _this = this;
      return list.map(function (row) {
        var next = _objectSpread({}, row);
        _this.dimensionMetrics.forEach(function (_ref) {
          var countKey = _ref.countKey,
            rateKey = _ref.rateKey;
          next[countKey] = (0, _utils.formatCount)(next[countKey]);
          next[rateKey] = (0, _utils.formatRate)(next[rateKey]);
        });
        return next;
      });
    },
    getHeaderCellStyle: function getHeaderCellStyle() {
      return {
        backgroundColor: '#f8faff'
      };
    },
    // 点击复制获客链接
    onCopyCustomerLink: function onCopyCustomerLink(link) {
      var _this2 = this;
      this.$copyText(link).then(function () {
        _this2.$message({
          type: 'success',
          message: '复制成功!',
          duration: 1000
        });
      }).catch(function () {
        _this2.$message.error('复制失败!');
      });
    },
    // 加粉不成功列表分页
    changeFailedTablePage: function changeFailedTablePage(page) {
      this.failedTableCurrentPage = page;
      this.clearFailedFilter();
      this.getFailedData();
    },
    // 清除加粉不成功订单明细表格筛选条件
    clearFailedFilter: function clearFailedFilter() {
      this.filterFailedOrderNo = '';
      this.filterFailedPattern = '';
      this.filterFailedGuide = '';
      this.filterFailedAccept = '';
      this.filterFailedChannelGroup = '';
      this.filterFailedRobotId = '';
      this.filterFailedRobotName = '';
      this.filterFailedPaidDateRange = [];
    },
    // 重置失败订单明细表格相关参数
    resetFailedTableParams: function resetFailedTableParams() {
      this.selectedFailedReason = '';
      this.showFailedTable = false;
      this.failedTableTotalPage = 1;
      this.failedTableCurrentPage = 1;
      this.failedTableTotal = 0;
      this.failedData = [];
      this.clearFailedFilter();
    },
    // 重置
    onReset: function onReset() {
      location.reload();
    },
    // 搜索
    onSearch: function onSearch() {
      this.getFunnelData();
      this.getDimensionData();

      //  重置失败订单明细表格相关参数
      this.resetFailedTableParams();
    },
    // 导出链路数据
    onExportFunnelData: function onExportFunnelData() {
      if (this.funnelData.length == 0) {
        this.$message({
          type: 'warning',
          message: '无数据不可导出'
        });
        return;
      }
      var tableData = this.funnelData.map(function (row) {
        return {
          链路环节: row.title,
          环节说明: row.desc,
          订单数: row.count,
          基准占比: row.baseRate,
          上一层转化率: row.upperRate
        };
      });
      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.json_to_sheet(tableData);
      XLSX.utils.book_append_sheet(wb, ws, 'sheet1');
      XLSX.writeFile(wb, "\u6570\u636E\u94FE\u8DEF\u76D1\u63A7_\u94FE\u8DEF\u6570\u636E_".concat(Date.now(), ".xlsx"));
    },
    // 导出维度数据
    onExportDimensionData: function () {
      var _onExportDimensionData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var params, response, url, filename;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!(this.dimensionData.length == 0)) {
                _context10.next = 3;
                break;
              }
              this.$message({
                type: 'warning',
                message: '无数据不可导出'
              });
              return _context10.abrupt("return");
            case 3:
              _context10.prev = 3;
              this.isExportingDimensionTable = true;
              params = this.getRequestParams();
              _context10.next = 8;
              return (0, _funnel.getFunnelAnalysisStatisticsDetailExport)(params);
            case 8:
              response = _context10.sent;
              if (response && response.data) {
                url = response.data.url;
                if (url) {
                  filename = "\u6570\u636E\u94FE\u8DEF\u76D1\u63A7_\u7EF4\u5EA6\u6570\u636E_".concat(Date.now(), ".xlsx");
                  this.downloadExcel(url, filename);
                }
              }
              _context10.next = 15;
              break;
            case 12:
              _context10.prev = 12;
              _context10.t0 = _context10["catch"](3);
              console.log(_context10.t0);
            case 15:
              _context10.prev = 15;
              this.isExportingDimensionTable = false;
              return _context10.finish(15);
            case 18:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this, [[3, 12, 15, 18]]);
      }));
      function onExportDimensionData() {
        return _onExportDimensionData.apply(this, arguments);
      }
      return onExportDimensionData;
    }(),
    // 导出加粉不成功数据 todo
    onExportFailedData: function () {
      var _onExportFailedData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var params, response, url, filename;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (!(this.failedData.length == 0)) {
                _context11.next = 3;
                break;
              }
              this.$message({
                type: 'warning',
                message: '无数据不可导出'
              });
              return _context11.abrupt("return");
            case 3:
              _context11.prev = 3;
              this.isExportingFailedTable = true;
              params = this.getRequestParams();
              params['failure_reason'] = this.selectedFailedReason || this.failedReasonsMap['all_failure'];
              _context11.next = 9;
              return (0, _funnel.getFunnelAnalysisOrderDetailExport)(params);
            case 9:
              response = _context11.sent;
              if (response && response.data) {
                url = response.data.url;
                if (url) {
                  filename = "\u6570\u636E\u94FE\u8DEF\u76D1\u63A7_\u52A0\u7C89\u4E0D\u6210\u529F\u6570\u636E_".concat(Date.now(), ".xlsx");
                  this.downloadExcel(url, filename);
                }
              }
              _context11.next = 16;
              break;
            case 13:
              _context11.prev = 13;
              _context11.t0 = _context11["catch"](3);
              console.log(_context11.t0);
            case 16:
              _context11.prev = 16;
              this.isExportingFailedTable = false;
              return _context11.finish(16);
            case 19:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this, [[3, 13, 16, 19]]);
      }));
      function onExportFailedData() {
        return _onExportFailedData.apply(this, arguments);
      }
      return onExportFailedData;
    }(),
    downloadExcel: function downloadExcel(url, filename) {
      var link = document.createElement('a');
      link.href = url;
      // 非同源不一定生效，暂时保留
      link.download = filename;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // 漏斗项点击处理
    onFunnelClick: function onFunnelClick(item) {
      // 展示加粉不成功明细表
      if (this.showFailedTable == false) {
        this.showFailedTable = true;
      }
      this.selectedFailedReason = item.failedReason;
    }
  }
};